export const LANGUAGE_OPTIONS = [
  { code: "en", label: "English", flag: "\ud83c\uddfa\ud83c\uddf8" },
  { code: "ch", label: "\u7e41\u9ad4\u4e2d\u6587", flag: "\ud83c\uddf9\ud83c\uddfc" },
  { code: "th", label: "\u0e44\u0e17\u0e22", flag: "\ud83c\uddf9\ud83c\udded" },
  { code: "ja", label: "\u65e5\u672c\u8a9e", flag: "\ud83c\uddef\ud83c\uddf5" },
];

export const DEFAULT_INVITE_CONFIG = {
  code: "",
  organization: "Manual session",
  campaign: "Manual preview",
  assessmentType: "school",
  role: "school",
  questionSet: "family-digital-wellbeing-v1",
  assessmentVersion: "post",
  flow: "post",
  showImmediateResults: true,
  allowDownload: true,
  allowEmail: true,
};

export const INVITE_ROLE_LABELS = {
  en: {
    school: "School Staff / Administrator",
    parent: "Parent / Guardian",
    student: "Student",
  },
  ch: {
    school: "\u5b78\u6821\u6559\u8077\u54e1 / \u7ba1\u7406\u54e1",
    parent: "\u5bb6\u9577 / \u76e3\u8b77\u4eba",
    student: "\u5b78\u751f",
  },
  th: {
    school: "\u0e1a\u0e38\u0e04\u0e25\u0e32\u0e01\u0e23 / \u0e1c\u0e39\u0e49\u0e1a\u0e23\u0e34\u0e2b\u0e32\u0e23\u0e42\u0e23\u0e07\u0e40\u0e23\u0e35\u0e22\u0e19",
    parent: "\u0e1c\u0e39\u0e49\u0e1b\u0e01\u0e04\u0e23\u0e2d\u0e07 / \u0e1c\u0e39\u0e49\u0e14\u0e39\u0e41\u0e25",
    student: "\u0e19\u0e31\u0e01\u0e40\u0e23\u0e35\u0e22\u0e19",
  },
  ja: {
    school: "\u6559\u8077\u54e1 / \u7ba1\u7406\u8005",
    parent: "\u4fdd\u8b77\u8005",
    student: "\u751f\u5f92",
  },
};

export const RESULT_CATEGORY_LABELS = {
  en: {
    "Digital Wellbeing Environment at Home": "Environment",
    "Family Communication on Digital Wellbeing and AI": "Communication",
    "Parental Resourcefulness and Self-Efficacy": "Resourcefulness",
    "School-Parent Communication": "School-Parent",
  },
  ch: {
    "\u5bb6\u5ead\u4e2d\u7684\u6578\u78bc\u5065\u5eb7\u74b0\u5883": "\u5bb6\u5ead\u74b0\u5883",
    "\u5bb6\u5ead\u5728\u6578\u78bc\u5065\u5eb7\u8207\u4eba\u5de5\u667a\u6167\u65b9\u9762\u7684\u6e9d\u901a": "\u5bb6\u5ead\u6e9d\u901a",
    "\u7236\u6bcd\u7684\u61c9\u8b8a\u80fd\u529b\u8207\u81ea\u6211\u6548\u80fd\u611f": "\u7236\u6bcd\u81ea\u4fe1",
    "\u5b78\u6821\u8207\u5bb6\u9577\u6e9d\u901a": "\u6821\u5bb6\u5408\u4f5c",
  },
  th: {
    "\u0e2a\u0e20\u0e32\u0e1e\u0e41\u0e27\u0e14\u0e25\u0e49\u0e2d\u0e21\u0e14\u0e49\u0e32\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e20\u0e32\u0e22\u0e43\u0e19\u0e1a\u0e49\u0e32\u0e19": "\u0e2a\u0e20\u0e32\u0e1e\u0e41\u0e27\u0e14\u0e25\u0e49\u0e2d\u0e21",
    "\u0e01\u0e32\u0e23\u0e2a\u0e37\u0e48\u0e2d\u0e2a\u0e32\u0e23\u0e43\u0e19\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e41\u0e25\u0e30 AI": "\u0e01\u0e32\u0e23\u0e2a\u0e37\u0e48\u0e2d\u0e2a\u0e32\u0e23",
    "\u0e04\u0e27\u0e32\u0e21\u0e23\u0e2d\u0e1a\u0e23\u0e39\u0e49\u0e41\u0e25\u0e30\u0e04\u0e27\u0e32\u0e21\u0e40\u0e0a\u0e37\u0e48\u0e2d\u0e21\u0e31\u0e48\u0e19\u0e43\u0e19\u0e15\u0e19\u0e40\u0e2d\u0e07\u0e02\u0e2d\u0e07\u0e1c\u0e39\u0e49\u0e1b\u0e01\u0e04\u0e23\u0e2d\u0e07": "\u0e04\u0e27\u0e32\u0e21\u0e21\u0e31\u0e48\u0e19\u0e43\u0e08",
    "\u0e01\u0e32\u0e23\u0e2a\u0e37\u0e48\u0e2d\u0e2a\u0e32\u0e23\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07\u0e42\u0e23\u0e07\u0e40\u0e23\u0e35\u0e22\u0e19\u0e41\u0e25\u0e30\u0e1c\u0e39\u0e49\u0e1b\u0e01\u0e04\u0e23\u0e2d\u0e07": "\u0e42\u0e23\u0e07\u0e40\u0e23\u0e35\u0e22\u0e19-\u0e1c\u0e39\u0e49\u0e1b\u0e01\u0e04\u0e23\u0e2d\u0e07",
  },
  ja: {
    "\u5bb6\u5ead\u306b\u304a\u3051\u308b\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u74b0\u5883": "\u5bb6\u5ead\u74b0\u5883",
    "\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u3068AI\u306b\u95a2\u3059\u308b\u5bb6\u65cf\u306e\u30b3\u30df\u30e5\u30cb\u30b1\u30fc\u30b7\u30e7\u30f3": "\u5bb6\u65cf\u306e\u5bfe\u8a71",
    "\u4fdd\u8b77\u8005\u306e\u5de5\u592b\u3068\u81ea\u5df1\u52b9\u529b\u611f": "\u4fdd\u8b77\u8005\u306e\u81ea\u4fe1",
    "\u5b66\u6821\u3068\u4fdd\u8b77\u8005\u306e\u30b3\u30df\u30e5\u30cb\u30b1\u30fc\u30b7\u30e7\u30f3": "\u5b66\u6821-\u5bb6\u5ead",
  },
};

const WELCOME_SHARED_BY_LANGUAGE = {
  en: {
    assessmentLanguages:
      "Available in English, 中文, ไทย, 日本語. Other languages upon request.",
    testimonyTitle: "Client Testimony",
    testimonyQuote:
      "Kigumi's Family Diagnostic provided the actionable data we needed to refine our digital literacy and well-being strategy. By identifying the specific understandings, attitudes, and concerns our families have regarding their children's digital lives, the tool replaced assumptions with clear insights. I recommend this diagnostic to any school leader looking to build a more informed and effective partnership with their parent community.",
    testimonyAuthor: "- Mr. Sean Snider, Primary School Principal, Bangkok",
    kigumiTitle: "About Kigumi Group",
    kigumiDescription:
      "Founded in 2023 in Hong Kong, Kigumi Group is a social enterprise delivering digital wellbeing and AI ethics education to schools, parents and enterprises across Asia. Kigumi operates KiguLab, a multilingual digital & AI platform for students; Alice, AI Digital Parenting Coach; and customises AI and digital wellbeing curricula for schools and enterprises.",
    productsTitle: "Our Key Products",
    product1Name: "KiguLab",
    product1Desc: "A Digital Literacy Course Platform",
    product2Name: "Alice",
    product2Desc: "Your Digital Parenting AI Coach",
    product3Name: "Family Digital Wellbeing Diagnostic",
    product3Desc: "Comprehensive parental competency evaluation",
    followUs: "Follow us for workshops and insights",
  },
  ch: {
    assessmentLanguages:
      "提供 English、中文、ไทย、日本語版本。其他語言可按需求安排。",
    testimonyTitle: "客戶見證",
    testimonyQuote:
      "Kigumi 的家庭診斷工具為我們提供了可行的數據，幫助我們優化數碼素養與數碼健康策略。透過辨識家長對孩子數碼生活的理解、態度與顧慮，這套工具讓我們能以真實洞察取代主觀假設。我會推薦任何希望與家長社群建立更有效夥伴關係的學校領導者使用這項診斷。",
    testimonyAuthor: "- Sean Snider 先生，曼谷國際學校小學校長",
    kigumiTitle: "關於 Kigumi Group",
    kigumiDescription:
      "Kigumi Group 於 2023 年在香港成立，是一間致力推動數碼健康與 AI 倫理教育的社會企業，服務遍及亞洲的學校、家長及企業。Kigumi 旗下包括面向學生的多語數碼與 AI 學習平台 KiguLab、AI 數碼教養助手 Alice，以及為學校與企業度身設計的 AI 與數碼健康課程。",
    productsTitle: "核心產品",
    product1Name: "KiguLab",
    product1Desc: "數碼素養課程平台",
    product2Name: "Alice",
    product2Desc: "你的 AI 數碼教養教練",
    product3Name: "家庭數碼健康診斷",
    product3Desc: "全面評估家長的數碼教養能力",
    followUs: "追蹤我們的工作坊與最新洞察",
  },
  th: {
    assessmentLanguages:
      "รองรับภาษา English, 中文, ไทย และ 日本語 หากต้องการภาษาอื่นสามารถติดต่อเพิ่มเติมได้",
    testimonyTitle: "เสียงสะท้อนจากลูกค้า",
    testimonyQuote:
      "แบบวินิจฉัยสำหรับครอบครัวของ Kigumi ช่วยให้เราได้ข้อมูลเชิงปฏิบัติที่นำไปใช้ปรับกลยุทธ์ด้านความฉลาดรู้ดิจิทัลและสุขภาวะของโรงเรียนได้จริง เครื่องมือนี้ช่วยให้เราเข้าใจมุมมอง ทัศนคติ และข้อกังวลของครอบครัวเกี่ยวกับชีวิตดิจิทัลของเด็กอย่างชัดเจน แทนที่จะคาดเดาเอง ฉันขอแนะนำเครื่องมือนี้ให้กับผู้นำโรงเรียนที่ต้องการสร้างความร่วมมือกับผู้ปกครองอย่างมีประสิทธิภาพมากขึ้น",
    testimonyAuthor: "- คุณ Sean Snider ผู้อำนวยการโรงเรียนประถม กรุงเทพฯ",
    kigumiTitle: "เกี่ยวกับ Kigumi Group",
    kigumiDescription:
      "Kigumi Group ก่อตั้งขึ้นในฮ่องกงในปี 2023 เป็นกิจการเพื่อสังคมที่มุ่งพัฒนาการศึกษาเรื่องสุขภาวะดิจิทัลและจริยธรรม AI ให้กับโรงเรียน ผู้ปกครอง และองค์กรทั่วเอเชีย Kigumi ดำเนินงานผ่าน KiguLab แพลตฟอร์มการเรียนรู้ด้านดิจิทัลและ AI หลายภาษา, Alice โค้ช AI ด้านการเลี้ยงดูดิจิทัล และหลักสูตรด้าน AI กับสุขภาวะดิจิทัลที่ออกแบบเฉพาะสำหรับโรงเรียนและองค์กร",
    productsTitle: "ผลิตภัณฑ์หลักของเรา",
    product1Name: "KiguLab",
    product1Desc: "แพลตฟอร์มหลักสูตรความฉลาดรู้ดิจิทัล",
    product2Name: "Alice",
    product2Desc: "โค้ช AI ด้านการเลี้ยงดูดิจิทัลของคุณ",
    product3Name: "การวินิจฉัยสุขภาวะดิจิทัลของครอบครัว",
    product3Desc: "การประเมินสมรรถนะของผู้ปกครองอย่างรอบด้าน",
    followUs: "ติดตามเวิร์กช็อปและบทความล่าสุดของเรา",
  },
  ja: {
    assessmentLanguages:
      "English、中文、ไทย、日本語に対応しています。その他の言語はご相談ください。",
    testimonyTitle: "導入校の声",
    testimonyQuote:
      "Kigumi のファミリー診断は、学校のデジタルリテラシーとウェルビーイング戦略を見直すために必要な実践的データを与えてくれました。子どものデジタル生活に対して保護者がどのような理解・態度・懸念を持っているかを可視化できたことで、推測ではなく明確な洞察に基づいた判断が可能になりました。保護者との連携をより効果的に築きたい学校リーダーに勧めたい診断です。",
    testimonyAuthor: "- Sean Snider 氏、バンコク小学校 校長",
    kigumiTitle: "Kigumi Group について",
    kigumiDescription:
      "Kigumi Group は 2023 年に香港で設立されたソーシャルエンタープライズで、アジア各地の学校、保護者、企業に対してデジタルウェルビーイングと AI 倫理教育を提供しています。学生向け多言語デジタル・AI 学習プラットフォーム KiguLab、AI デジタル子育てコーチ Alice、そして学校や企業向けに最適化した AI・デジタルウェルビーイングカリキュラムを展開しています。",
    productsTitle: "主なプロダクト",
    product1Name: "KiguLab",
    product1Desc: "デジタルリテラシー学習プラットフォーム",
    product2Name: "Alice",
    product2Desc: "AI デジタル子育てコーチ",
    product3Name: "ファミリー・デジタルウェルビーイング診断",
    product3Desc: "保護者コンピテンシーを多面的に評価",
    followUs: "ワークショップや最新インサイトをフォロー",
  },
};

export const EXPERIENCE_COPY = {
  en: {
    welcome: {
      selectLanguage: "Language",
      title: "Welcome to the",
      titleHighlight: "Digital Wellbeing Assessment",
      subtitle:
        "Discover your family's digital parenting readiness through our comprehensive evaluation framework",
      assessmentTitle: "Family Cybersafety & Digital Wellbeing Diagnostic Test",
      assessmentDescription:
        "Know what your parents need before you invest in a parenting programme. Our cybersafety & digital wellbeing diagnostic test for parents and caregivers takes minutes and delivers personalised insights and scores across four domains of parental competencies.",
      startAssessmentButton: "Start Assessment",
      startButton: "Continue to Assessment",
      languageNote: "The entire assessment is available in your selected language",
      ...WELCOME_SHARED_BY_LANGUAGE.en,
    },
    landing: {
      inviteCode: "Invite Code",
      missingInviteCode: "Manual entry",
      title: "Family Digital Wellbeing Assessment",
      subtitle:
        "Understand your current digital wellbeing environment before deciding what support families need next.",
      duration: "10-15 minutes",
      durationDesc:
        "A focused diagnostic that can be completed in a single sitting on desktop or mobile.",
      noLogin: "No login required",
      noLoginDesc:
        "Start from your invite link or enter your invite code during onboarding.",
      oneTimeReport: "Config-driven report access",
      oneTimeReportDesc:
        "Invite codes can control the role, assessment phase, and whether results, downloads, or email are enabled.",
      startButton: "Start Assessment",
      footerNote:
        "Your answers help Kigumi and school partners understand where to support families next.",
      invitationLink: "Invitation link",
      invitationLinkConfirmed: "Invitation link confirmed",
      invitationLinkLoading: "Checking invitation link...",
      invitationLinkNote: "No invite code is required when you use this link.",
      inviteCodeConfirmed: "Invite code confirmed",
      inviteCodeLoading: "Checking invite code...",
      inviteCodeInvalid:
        "This invite code could not be found. You can keep going in manual mode on /diagnostic, or use a valid /start link.",
    },
    form: {
      title: "Basic Information",
      subtitle: "Please provide your details to begin the assessment",
      fullName: "Full Name",
      email: "Email Address",
      role: "I am a...",
      studentClass: "Student Class",
      inviteCode: "Invite Code",
      language: "Assessment Language",
      inviteCodeNote:
        "This code is auto-filled from your invite link when available. You can also enter it manually here.",
      inviteLinkConfirmedTitle: "Invitation link confirmed",
      inviteLinkConfirmedNote:
        "No invite code is required. This link keeps the assessment in the correct flow.",
      inviteCodeLockedNote:
        "This invite code came from your invitation link and is locked to preserve the correct assessment flow.",
      roleLocked: "This role was inferred from your invitation link.",
      terms: "I certify that I have read and agree to the Terms and Conditions.",
      submitButton: "Begin Assessment",
      backButton: "Back",
      submitDisabledInvite: "A valid invite code is required for this link.",
      placeholders: {
        fullName: "Enter your full name",
        email: "your.email@example.com",
        studentClass: "e.g., Grade 10A",
        inviteCode: "Enter invite code",
      },
      errors: {
        nameRequired: "Please enter your full name",
        emailRequired: "Please enter your email address",
        emailInvalid: "Please enter a valid email address",
        inviteRequired: "Please enter a valid invite code to continue",
        termsRequired:
          "Please confirm that you have read and agreed to the terms and conditions",
      },
    },
    assessment: {
      brand: "Digital Wellbeing Assessment",
      inviteCode: "Invite Code",
      backButton: "Back",
      nextButton: "Next",
      completeButton: "Complete",
      dragInstruction:
        "Drag and drop to reorder from most important (1) to least important",
      helperDefault: "Choose the response that best matches your situation.",
      helperCheckbox: "Select every option that applies.",
      helperRanking: "Drag each item into its preferred order.",
      helperGrouped: "Answer each line before moving forward.",
      helperText: "Type your answer in your own words.",
      helperLikert: "Select one option only.",
      otherPlaceholder: "Please specify",
      errorAnswerRequired: "Please answer this question before continuing.",
      errorOtherRequired:
        "Please specify your \"Other\" response before continuing.",
    },
    completion: {
      title: "Assessment Complete",
      subtitle: "Thank you for your participation.",
      resultsReady: "Your digital wellbeing report is ready to view.",
      viewResultsButton: "View Your Results",
      emailSent: "Your report is being prepared for email delivery.",
      emailNote: "Please check your inbox within the next 24 hours.",
      savedNote:
        "Your responses have been recorded. The organizer will share the report based on this invite configuration.",
      emailError:
        "We couldn't email the report automatically. Please try again later or contact the organizer.",
    },
    results: {
      brand: "Digital Wellbeing Report",
      inviteCode: "Invite Code",
      title: "Digital Wellbeing Assessment Results",
      overallScore: "Overall Digital Wellbeing Score",
      overallScoreDesc:
        "Based on your responses across four key dimensions of the family digital wellbeing diagnostic.",
      outOf: "/ 100",
      categoryBreakdown: "Category Breakdown",
      scoreComparison: "Score Comparison",
      downloadButton: "Save Report",
      strengthsTitle: "What this means",
      nextStepsTitle: "Suggested next steps",
      scoreBadgeLabel: "Score",
    },
    delivery: {
      brand: "Digital Wellbeing Report",
      inviteCode: "Invite Code",
      title: "Save Your Report",
      subtitle:
        "Choose how you'd like to keep a copy of your digital wellbeing diagnostic report",
      warningTitle: "Important: One-time access only",
      warningDesc:
        "This report may not remain available indefinitely. Download or email it now if you need a copy.",
      downloadPDF: "Download PDF Report",
      downloadPDFDesc:
        "Get a full PDF document with your score, category breakdown, and next-step guidance.",
      emailReport: "Email Report",
      emailReportDesc: "Send the report to",
      supportNote: "Need help? Contact support@kigumigroup.com",
      unavailable: "This delivery method is disabled for the current invite code.",
      emailSending: "Sending...",
    },
    footer: {
      stayUpdated: "Stay Updated",
      description:
        "Get the latest insights on digital education and AI ethics",
      placeholder: "Enter your email",
      subscribe: "Subscribe",
      marketingConsent:
        "I agree to receive marketing communications from Kigumigroup",
      followUs: "Follow Us",
      copyright: "\u00a9 Kigumi Group 2026",
      confirmationTitle: "Subscription Confirmed!",
      confirmationMessage:
        "Thank you for subscribing! You will receive the latest updates at",
      confirmationButton: "Got it",
    },
  },
  ch: {
    welcome: {
      selectLanguage: "Language",
      title: "\u6b61\u8fce\u4f7f\u7528",
      titleHighlight: "\u6578\u78bc\u5065\u5eb7\u8a3a\u65b7",
      subtitle:
        "\u4ee5\u66f4\u6e05\u6670\u7684\u65b9\u5f0f\u4e86\u89e3\u5bb6\u5ead\u6578\u78bc\u6559\u990a\u8207\u5065\u5eb7\u73fe\u6cc1",
      assessmentTitle: "\u5bb6\u5ead\u7db2\u7d61\u5b89\u5168\u8207\u6578\u78bc\u5065\u5eb7\u8a3a\u65b7\u6e2c\u8a66",
      assessmentDescription:
        "在投入家長教育課程前，先掌握家長真正需要的支持。這份家長與照顧者數碼健康診斷只需數分鐘，便可依據四個核心能力構面提供個人化洞察與分數。",
      startAssessmentButton: "\u958b\u59cb\u8a55\u4f30",
      startButton: "\u7e7c\u7e8c\u9032\u5165\u8a55\u4f30",
      languageNote: "\u6574\u500b\u6d41\u7a0b\u90fd\u652f\u63f4\u60a8\u6240\u9078\u64c7\u7684\u8a9e\u8a00",
      ...WELCOME_SHARED_BY_LANGUAGE.ch,
    },
    landing: {
      inviteCode: "\u9080\u8acb\u78bc",
      missingInviteCode: "\u624b\u52d5\u8f38\u5165",
      title: "\u5bb6\u5ead\u6578\u78bc\u5065\u5eb7\u8a55\u4f30",
      subtitle:
        "\u5728\u898f\u5283\u4e0b\u4e00\u6b65\u652f\u63f4\u524d\uff0c\u5148\u4e86\u89e3\u60a8\u7576\u524d\u7684\u6578\u78bc\u5065\u5eb7\u72c0\u6cc1\u3002",
      duration: "10-15\u5206\u9418",
      durationDesc:
        "\u53ef\u5728\u684c\u6a5f\u6216\u624b\u6a5f\u4e0a\u4e00\u6b21\u5b8c\u6210\u7684\u805a\u7126\u5f0f\u8a3a\u65b7\u3002",
      noLogin: "\u7121\u9700\u767b\u5165",
      noLoginDesc:
        "\u53ef\u7531\u9080\u8acb\u9023\u7d50\u9032\u5165\uff0c\u4e5f\u53ef\u5728\u586b\u8868\u6642\u624b\u52d5\u8f38\u5165\u9080\u8acb\u78bc\u3002",
      oneTimeReport: "\u8a66\u984c\u8207\u5831\u544a\u7531\u9080\u8acb\u78bc\u63a7\u5236",
      oneTimeReportDesc:
        "\u9080\u8acb\u78bc\u53ef\u6c7a\u5b9a\u89d2\u8272\uff0c\u6e2c\u8a66\u968e\u6bb5\uff0c\u4ee5\u53ca\u7d50\u679c\u3001\u4e0b\u8f09\u8207\u96fb\u90f5\u9078\u9805\u3002",
      startButton: "\u958b\u59cb\u8a55\u4f30",
      footerNote:
        "\u60a8\u7684\u56de\u7b54\u5c07\u5e6b\u52a9 Kigumi \u8207\u5b78\u6821\u5925\u4f34\u66f4\u6e05\u695a\u5730\u4e86\u89e3\u5bb6\u5ead\u9700\u6c42\u3002",
      invitationLink: "\u9080\u8acb\u9023\u7d50",
      invitationLinkConfirmed: "\u9080\u8acb\u9023\u7d50\u5df2\u78ba\u8a8d",
      invitationLinkLoading: "\u6aa2\u67e5\u9080\u8acb\u9023\u7d50\u4e2d...",
      invitationLinkNote:
        "\u4f7f\u7528\u6b64\u9023\u7d50\u6642\uff0c\u7121\u9700\u8f38\u5165\u9080\u8acb\u78bc\u3002",
      inviteCodeConfirmed: "\u9080\u8acb\u78bc\u5df2\u78ba\u8a8d",
      inviteCodeLoading: "\u6aa2\u67e5\u9080\u8acb\u78bc\u4e2d...",
      inviteCodeInvalid:
        "\u627e\u4e0d\u5230\u9019\u7d44\u9080\u8acb\u78bc\u3002\u60a8\u53ef\u4ee5\u5728 /diagnostic \u4ee5\u624b\u52d5\u6a21\u5f0f\u7e7c\u7e8c\uff0c\u6216\u6539\u7528\u6b63\u78ba\u7684 /start \u9023\u7d50\u3002",
    },
    form: {
      title: "\u57fa\u672c\u8cc7\u8a0a",
      subtitle: "\u8acb\u5148\u63d0\u4f9b\u60a8\u7684\u8cc7\u6599\uff0c\u518d\u958b\u59cb\u8a55\u4f30",
      fullName: "\u5168\u540d",
      email: "\u96fb\u5b50\u90f5\u4ef6\u5730\u5740",
      role: "\u6211\u7684\u8eab\u4efd\u662f...",
      studentClass: "\u5b78\u751f\u73ed\u7d1a",
      inviteCode: "\u9080\u8acb\u78bc",
      language: "\u8a55\u4f30\u8a9e\u8a00",
      inviteCodeNote:
        "\u82e5\u901a\u904e\u9080\u8acb\u9023\u7d50\u9032\u5165\uff0c\u9080\u8acb\u78bc\u6703\u81ea\u52d5\u5e36\u5165\uff0c\u4e5f\u53ef\u5728\u6b64\u624b\u52d5\u8f38\u5165\u3002",
      inviteLinkConfirmedTitle: "\u9080\u8acb\u9023\u7d50\u5df2\u78ba\u8a8d",
      inviteLinkConfirmedNote:
        "\u7121\u9700\u8f38\u5165\u9080\u8acb\u78bc\u3002\u6b64\u9023\u7d50\u6703\u4fdd\u6301\u6b63\u78ba\u7684\u8a55\u4f30\u6d41\u7a0b\u3002",
      inviteCodeLockedNote:
        "\u6b64\u9080\u8acb\u78bc\u4f86\u81ea\u60a8\u7684\u9080\u8acb\u9023\u7d50\uff0c\u70ba\u907f\u514d\u5f71\u97ff\u6e2c\u9a57\u7248\u672c\u8207\u984c\u7d44\uff0c\u5df2\u9396\u5b9a\u7121\u6cd5\u4fee\u6539\u3002",
      roleLocked: "\u6b64\u89d2\u8272\u7531\u60a8\u7684\u9080\u8acb\u9023\u7d50\u81ea\u52d5\u63a8\u65b7\u3002",
      terms: "\u6211\u78ba\u8a8d\u5df2\u95b1\u8b80\u4e26\u540c\u610f\u689d\u6b3e\u8207\u7d30\u5247\u3002",
      submitButton: "\u958b\u59cb\u8a55\u4f30",
      backButton: "\u8fd4\u56de",
      submitDisabledInvite: "\u6b64\u9023\u7d50\u9700\u8981\u6709\u6548\u7684\u9080\u8acb\u78bc\u624d\u80fd\u7e7c\u7e8c\u3002",
      placeholders: {
        fullName: "\u8f38\u5165\u60a8\u7684\u5168\u540d",
        email: "your.email@example.com",
        studentClass: "\u4f8b\u5982\uff1a10\u5e74\u7d1a A \u73ed",
        inviteCode: "\u8f38\u5165\u9080\u8acb\u78bc",
      },
      errors: {
        nameRequired: "\u8acb\u8f38\u5165\u60a8\u7684\u5168\u540d",
        emailRequired: "\u8acb\u8f38\u5165\u60a8\u7684\u96fb\u5b50\u90f5\u4ef6",
        emailInvalid: "\u8acb\u8f38\u5165\u6709\u6548\u7684\u96fb\u5b50\u90f5\u4ef6",
        inviteRequired: "\u8acb\u8f38\u5165\u6709\u6548\u7684\u9080\u8acb\u78bc",
        termsRequired: "\u8acb\u78ba\u8a8d\u60a8\u5df2\u95b1\u8b80\u4e26\u540c\u610f\u689d\u6b3e\u8207\u7d30\u5247",
      },
    },
    assessment: {
      brand: "\u6578\u78bc\u5065\u5eb7\u8a55\u4f30",
      inviteCode: "\u9080\u8acb\u78bc",
      backButton: "\u8fd4\u56de",
      nextButton: "\u4e0b\u4e00\u984c",
      completeButton: "\u5b8c\u6210",
      dragInstruction:
        "\u8acb\u5c07\u9805\u76ee\u5f9e\u6700\u91cd\u8981 (1) \u62d6\u66f3\u5230\u6700\u4e0d\u91cd\u8981",
      helperDefault: "\u9078\u64c7\u6700\u7b26\u5408\u60a8\u60c5\u6cc1\u7684\u56de\u7b54\u3002",
      helperCheckbox: "\u53ef\u8907\u9078\u6240\u6709\u9069\u7528\u7684\u9078\u9805\u3002",
      helperRanking: "\u8acb\u62d6\u66f3\u4ee5\u5b8c\u6210\u6392\u5e8f\u3002",
      helperGrouped: "\u8acb\u5148\u56de\u7b54\u6bcf\u4e00\u884c\u518d\u7e7c\u7e8c\u3002",
      helperText: "\u8acb\u4ee5\u60a8\u81ea\u5df1\u7684\u6587\u5b57\u56de\u7b54\u3002",
      helperLikert: "\u8acb\u9078\u64c7\u4e00\u500b\u9078\u9805\u3002",
      otherPlaceholder: "\u8acb\u8aaa\u660e",
      errorAnswerRequired: "\u8acb\u5148\u56de\u7b54\u9019\u500b\u554f\u984c\u518d\u7e7c\u7e8c\u3002",
      errorOtherRequired:
        "\u8acb\u5148\u88dc\u5145\u300c\u5176\u4ed6\u300d\u7684\u5167\u5bb9\u518d\u7e7c\u7e8c\u3002",
    },
    completion: {
      title: "\u8a55\u4f30\u5df2\u5b8c\u6210",
      subtitle: "\u611f\u8b1d\u60a8\u7684\u53c3\u8207\u3002",
      resultsReady: "\u60a8\u7684\u5831\u544a\u5df2\u53ef\u4ee5\u67e5\u770b\u3002",
      viewResultsButton: "\u6aa2\u8996\u7d50\u679c",
      emailSent: "\u5831\u544a\u6b63\u5728\u6e96\u5099\u4ee5\u96fb\u90f5\u5bc4\u9001\u3002",
      emailNote: "\u8acb\u5728 24 \u5c0f\u6642\u5167\u6aa2\u67e5\u60a8\u7684\u6536\u4ef6\u7bb1\u3002",
      savedNote:
        "\u60a8\u7684\u56de\u7b54\u5df2\u8a18\u9304\u3002\u5831\u544a\u6703\u4f9d\u9019\u7d44\u9080\u8acb\u78bc\u7684\u8a2d\u5b9a\u7531\u4e3b\u8fa6\u65b9\u5206\u4eab\u3002",
      emailError:
        "\u7121\u6cd5\u81ea\u52d5\u7528\u96fb\u90f5\u5bc4\u9001\u5831\u544a\uff0c\u8acb\u7a0d\u5f8c\u518d\u8a66\u6216\u806f\u7d61\u4e3b\u8fa6\u65b9\u3002",
    },
    results: {
      brand: "\u6578\u78bc\u5065\u5eb7\u5831\u544a",
      inviteCode: "\u9080\u8acb\u78bc",
      title: "\u6578\u78bc\u5065\u5eb7\u8a55\u4f30\u7d50\u679c",
      overallScore: "\u6574\u9ad4\u5206\u6578",
      overallScoreDesc:
        "\u6839\u64da\u60a8\u5728\u56db\u500b\u91cd\u8981\u69cb\u9762\u7684\u56de\u7b54\u6240\u5f97\u51fa\u7684\u7d9c\u5408\u7d50\u679c\u3002",
      outOf: "/ 100",
      categoryBreakdown: "\u985e\u5225\u7d30\u5206",
      scoreComparison: "\u5206\u6578\u6bd4\u8f03",
      downloadButton: "\u5132\u5b58\u5831\u544a",
      strengthsTitle: "\u9019\u4ee3\u8868\u4ec0\u9ebc",
      nextStepsTitle: "\u5efa\u8b70\u4e0b\u4e00\u6b65",
      scoreBadgeLabel: "\u5206\u6578",
    },
    delivery: {
      brand: "\u6578\u78bc\u5065\u5eb7\u5831\u544a",
      inviteCode: "\u9080\u8acb\u78bc",
      title: "\u5132\u5b58\u60a8\u7684\u5831\u544a",
      subtitle:
        "\u9078\u64c7\u60a8\u60f3\u5982\u4f55\u4fdd\u7559\u9019\u4efd\u6578\u78bc\u5065\u5eb7\u8a3a\u65b7\u5831\u544a",
      warningTitle: "\u91cd\u8981\uff1a\u5831\u544a\u53ef\u80fd\u53ea\u6709\u4e00\u6b21\u53d6\u5f97\u6a5f\u6703",
      warningDesc:
        "\u82e5\u60a8\u9700\u8981\u4fdd\u7559\u526f\u672c\uff0c\u5efa\u8b70\u73fe\u5728\u7acb\u5373\u4e0b\u8f09\u6216\u5bc4\u9001\u81f3\u96fb\u5b50\u90f5\u4ef6\u3002",
      downloadPDF: "\u4e0b\u8f09 PDF \u5831\u544a",
      downloadPDFDesc:
        "\u53d6\u5f97\u5b8c\u6574\u7684 PDF \u6587\u4ef6\uff0c\u5305\u542b\u5206\u6578\uff0c\u985e\u5225\u7d50\u679c\u8207\u5efa\u8b70\u884c\u52d5\u3002",
      emailReport: "\u96fb\u90f5\u5831\u544a",
      emailReportDesc: "\u5c07\u5831\u544a\u5bc4\u9001\u81f3",
      supportNote: "\u82e5\u9700\u8981\u5354\u52a9\uff0c\u8acb\u806f\u7d61 support@kigumigroup.com",
      unavailable: "\u9019\u7a2e\u5132\u5b58\u65b9\u5f0f\u5df2\u88ab\u76ee\u524d\u7684\u9080\u8acb\u78bc\u505c\u7528\u3002",
      emailSending: "\u5bc4\u9001\u4e2d...",
    },
    footer: {
      stayUpdated: "\u4fdd\u6301\u6700\u65b0\u8cc7\u8a0a",
      description:
        "\u7372\u53d6\u95dc\u65bc\u6578\u78bc\u6559\u80b2\u8207 AI \u502b\u7406\u7684\u6700\u65b0\u898b\u89e3",
      placeholder: "\u8f38\u5165\u60a8\u7684\u96fb\u5b50\u90f5\u4ef6",
      subscribe: "\u8a02\u95b1",
      marketingConsent:
        "\u6211\u540c\u610f\u63a5\u6536\u4f86\u81ea Kigumigroup \u7684\u884c\u92b7\u8cc7\u8a0a",
      followUs: "\u95dc\u6ce8\u6211\u5011",
      copyright: "\u00a9 Kigumi Group 2026",
      confirmationTitle: "\u8a02\u95b1\u5df2\u78ba\u8a8d\uff01",
      confirmationMessage:
        "\u611f\u8b1d\u60a8\u7684\u8a02\u95b1\uff01\u6211\u5011\u6703\u5c07\u6700\u65b0\u8cc7\u8a0a\u5bc4\u5230",
      confirmationButton: "\u6211\u77e5\u9053\u4e86",
    },
  },
  th: {
    welcome: {
      selectLanguage: "Language",
      title: "\u0e22\u0e34\u0e19\u0e14\u0e35\u0e15\u0e49\u0e2d\u0e19\u0e23\u0e31\u0e1a\u0e2a\u0e39\u0e48",
      titleHighlight: "\u0e01\u0e32\u0e23\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25",
      subtitle:
        "\u0e17\u0e33\u0e04\u0e27\u0e32\u0e21\u0e40\u0e02\u0e49\u0e32\u0e43\u0e08\u0e04\u0e27\u0e32\u0e21\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e14\u0e49\u0e32\u0e19\u0e01\u0e32\u0e23\u0e40\u0e25\u0e35\u0e49\u0e22\u0e07\u0e14\u0e39\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e02\u0e2d\u0e07\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27\u0e1c\u0e48\u0e32\u0e19\u0e01\u0e23\u0e2d\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e19\u0e35\u0e49",
      assessmentTitle:
        "\u0e41\u0e1a\u0e1a\u0e17\u0e14\u0e2a\u0e2d\u0e1a\u0e27\u0e34\u0e19\u0e34\u0e08\u0e09\u0e31\u0e22\u0e14\u0e49\u0e32\u0e19\u0e04\u0e27\u0e32\u0e21\u0e1b\u0e25\u0e2d\u0e14\u0e20\u0e31\u0e22\u0e44\u0e0b\u0e40\u0e1a\u0e2d\u0e23\u0e4c\u0e41\u0e25\u0e30\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e02\u0e2d\u0e07\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27",
      assessmentDescription:
        "ก่อนที่โรงเรียนจะลงทุนในโครงการสำหรับผู้ปกครอง ควรเข้าใจให้ชัดว่าครอบครัวต้องการการสนับสนุนแบบใด แบบวินิจฉัยนี้ใช้เวลาเพียงไม่กี่นาทีและให้ข้อมูลเชิงลึกพร้อมคะแนนรายบุคคลใน 4 มิติของสมรรถนะผู้ปกครอง",
      startAssessmentButton: "\u0e40\u0e23\u0e34\u0e48\u0e21\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19",
      startButton: "\u0e14\u0e33\u0e40\u0e19\u0e34\u0e19\u0e01\u0e32\u0e23\u0e15\u0e48\u0e2d",
      languageNote: "\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14\u0e08\u0e30\u0e41\u0e2a\u0e14\u0e07\u0e15\u0e32\u0e21\u0e20\u0e32\u0e29\u0e32\u0e17\u0e35\u0e48\u0e04\u0e38\u0e13\u0e40\u0e25\u0e37\u0e2d\u0e01",
      ...WELCOME_SHARED_BY_LANGUAGE.th,
    },
    landing: {
      inviteCode: "\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d",
      missingInviteCode: "\u0e01\u0e23\u0e2d\u0e01\u0e14\u0e49\u0e27\u0e22\u0e15\u0e19\u0e40\u0e2d\u0e07",
      title: "\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e02\u0e2d\u0e07\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27",
      subtitle:
        "\u0e17\u0e33\u0e04\u0e27\u0e32\u0e21\u0e40\u0e02\u0e49\u0e32\u0e43\u0e08\u0e2a\u0e20\u0e32\u0e1e\u0e41\u0e27\u0e14\u0e25\u0e49\u0e2d\u0e21\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e43\u0e19\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19\u0e01\u0e48\u0e2d\u0e19\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e41\u0e19\u0e27\u0e17\u0e32\u0e07\u0e2a\u0e19\u0e31\u0e1a\u0e2a\u0e19\u0e38\u0e19",
      duration: "10-15 \u0e19\u0e32\u0e17\u0e35",
      durationDesc:
        "\u0e01\u0e32\u0e23\u0e27\u0e34\u0e19\u0e34\u0e08\u0e09\u0e31\u0e22\u0e17\u0e35\u0e48\u0e17\u0e33\u0e08\u0e1a\u0e44\u0e14\u0e49\u0e43\u0e19\u0e04\u0e23\u0e31\u0e49\u0e07\u0e40\u0e14\u0e35\u0e22\u0e27\u0e17\u0e31\u0e49\u0e07\u0e1a\u0e19\u0e04\u0e2d\u0e21\u0e1e\u0e34\u0e27\u0e40\u0e15\u0e2d\u0e23\u0e4c\u0e41\u0e25\u0e30\u0e21\u0e37\u0e2d\u0e16\u0e37\u0e2d",
      noLogin: "\u0e44\u0e21\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e23\u0e30\u0e1a\u0e1a",
      noLoginDesc:
        "\u0e40\u0e23\u0e34\u0e48\u0e21\u0e08\u0e32\u0e01\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d\u0e2b\u0e23\u0e37\u0e2d\u0e01\u0e23\u0e2d\u0e01\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e40\u0e2d\u0e07\u0e43\u0e19\u0e1f\u0e2d\u0e23\u0e4c\u0e21",
      oneTimeReport: "\u0e42\u0e04\u0e49\u0e14\u0e40\u0e0a\u0e34\u0e0d\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e1e\u0e24\u0e15\u0e34\u0e01\u0e23\u0e23\u0e21\u0e02\u0e2d\u0e07\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19",
      oneTimeReportDesc:
        "\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e1a\u0e17\u0e1a\u0e32\u0e17 \u0e40\u0e1f\u0e2a\u0e01\u0e32\u0e23\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19 \u0e41\u0e25\u0e30\u0e15\u0e31\u0e27\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e41\u0e2a\u0e14\u0e07\u0e1c\u0e25/\u0e14\u0e32\u0e27\u0e19\u0e4c\u0e42\u0e2b\u0e25\u0e14/\u0e2d\u0e35\u0e40\u0e21\u0e25",
      startButton: "\u0e40\u0e23\u0e34\u0e48\u0e21\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19",
      footerNote:
        "\u0e04\u0e33\u0e15\u0e2d\u0e1a\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e0a\u0e48\u0e27\u0e22\u0e43\u0e2b\u0e49 Kigumi \u0e41\u0e25\u0e30\u0e42\u0e23\u0e07\u0e40\u0e23\u0e35\u0e22\u0e19\u0e1e\u0e31\u0e19\u0e18\u0e21\u0e34\u0e15\u0e23\u0e40\u0e02\u0e49\u0e32\u0e43\u0e08\u0e04\u0e27\u0e32\u0e21\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e02\u0e2d\u0e07\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27",
      invitationLink: "\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d",
      invitationLinkConfirmed:
        "\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d\u0e41\u0e25\u0e49\u0e27",
      invitationLinkLoading:
        "\u0e01\u0e33\u0e25\u0e31\u0e07\u0e15\u0e23\u0e27\u0e08\u0e2a\u0e2d\u0e1a\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d...",
      invitationLinkNote:
        "\u0e44\u0e21\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e43\u0e0a\u0e49\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e40\u0e1b\u0e34\u0e14\u0e08\u0e32\u0e01\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e19\u0e35\u0e49",
      inviteCodeConfirmed: "\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e41\u0e25\u0e49\u0e27",
      inviteCodeLoading: "\u0e01\u0e33\u0e25\u0e31\u0e07\u0e15\u0e23\u0e27\u0e08\u0e2a\u0e2d\u0e1a\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d...",
      inviteCodeInvalid:
        "\u0e44\u0e21\u0e48\u0e1e\u0e1a\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e19\u0e35\u0e49 \u0e04\u0e38\u0e13\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e43\u0e0a\u0e49 /diagnostic \u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e17\u0e14\u0e2a\u0e2d\u0e1a\u0e41\u0e1a\u0e1a\u0e21\u0e37\u0e2d\u0e2b\u0e23\u0e37\u0e2d\u0e40\u0e1b\u0e34\u0e14 /start \u0e14\u0e49\u0e27\u0e22\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e17\u0e35\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07",
    },
    form: {
      title: "\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e40\u0e1a\u0e37\u0e49\u0e2d\u0e07\u0e15\u0e49\u0e19",
      subtitle: "\u0e42\u0e1b\u0e23\u0e14\u0e01\u0e23\u0e2d\u0e01\u0e23\u0e32\u0e22\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e23\u0e34\u0e48\u0e21\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19",
      fullName: "\u0e0a\u0e37\u0e48\u0e2d-\u0e19\u0e32\u0e21\u0e2a\u0e01\u0e38\u0e25",
      email: "\u0e2d\u0e35\u0e40\u0e21\u0e25",
      role: "\u0e09\u0e31\u0e19\u0e40\u0e1b\u0e47\u0e19...",
      studentClass: "\u0e0a\u0e31\u0e49\u0e19\u0e40\u0e23\u0e35\u0e22\u0e19",
      inviteCode: "\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d",
      language: "\u0e20\u0e32\u0e29\u0e32\u0e02\u0e2d\u0e07\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19",
      inviteCodeNote:
        "\u0e2b\u0e32\u0e01\u0e40\u0e02\u0e49\u0e32\u0e21\u0e32\u0e08\u0e32\u0e01\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d \u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e08\u0e30\u0e16\u0e39\u0e01\u0e01\u0e23\u0e2d\u0e01\u0e43\u0e2b\u0e49\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34 \u0e41\u0e25\u0e30\u0e04\u0e38\u0e13\u0e22\u0e31\u0e07\u0e01\u0e23\u0e2d\u0e01\u0e40\u0e2d\u0e07\u0e44\u0e14\u0e49",
      inviteLinkConfirmedTitle:
        "\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d\u0e41\u0e25\u0e49\u0e27",
      inviteLinkConfirmedNote:
        "\u0e44\u0e21\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e23\u0e2d\u0e01\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d \u0e25\u0e34\u0e07\u0e01\u0e4c\u0e19\u0e35\u0e49\u0e08\u0e30\u0e1e\u0e32\u0e44\u0e1b\u0e22\u0e31\u0e07\u0e02\u0e31\u0e49\u0e19\u0e15\u0e2d\u0e19\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e17\u0e35\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07",
      inviteCodeLockedNote:
        "\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e19\u0e35\u0e49\u0e21\u0e32\u0e08\u0e32\u0e01\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e41\u0e25\u0e30\u0e16\u0e39\u0e01\u0e25\u0e47\u0e2d\u0e01\u0e44\u0e27\u0e49 \u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e1b\u0e49\u0e2d\u0e07\u0e01\u0e31\u0e19\u0e01\u0e32\u0e23\u0e40\u0e1b\u0e25\u0e35\u0e48\u0e22\u0e19\u0e0a\u0e38\u0e14\u0e04\u0e33\u0e16\u0e32\u0e21\u0e2b\u0e23\u0e37\u0e2d\u0e23\u0e39\u0e1b\u0e41\u0e1a\u0e1a\u0e01\u0e32\u0e23\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e42\u0e14\u0e22\u0e44\u0e21\u0e48\u0e15\u0e31\u0e49\u0e07\u0e43\u0e08",
      roleLocked:
        "\u0e1a\u0e17\u0e1a\u0e32\u0e17\u0e19\u0e35\u0e49\u0e16\u0e39\u0e01\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e08\u0e32\u0e01\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e40\u0e0a\u0e34\u0e0d\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13",
      terms: "\u0e09\u0e31\u0e19\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e27\u0e48\u0e32\u0e44\u0e14\u0e49\u0e2d\u0e48\u0e32\u0e19\u0e41\u0e25\u0e30\u0e22\u0e2d\u0e21\u0e23\u0e31\u0e1a Terms and Conditions \u0e41\u0e25\u0e49\u0e27",
      submitButton: "\u0e40\u0e23\u0e34\u0e48\u0e21\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19",
      backButton: "\u0e22\u0e49\u0e2d\u0e19\u0e01\u0e25\u0e31\u0e1a",
      submitDisabledInvite: "\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e19\u0e35\u0e49\u0e15\u0e49\u0e2d\u0e07\u0e43\u0e0a\u0e49\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e17\u0e35\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07",
      placeholders: {
        fullName: "\u0e01\u0e23\u0e2d\u0e01\u0e0a\u0e37\u0e48\u0e2d-\u0e19\u0e32\u0e21\u0e2a\u0e01\u0e38\u0e25",
        email: "your.email@example.com",
        studentClass: "\u0e40\u0e0a\u0e48\u0e19 Grade 10A",
        inviteCode: "\u0e01\u0e23\u0e2d\u0e01\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d",
      },
      errors: {
        nameRequired: "\u0e42\u0e1b\u0e23\u0e14\u0e01\u0e23\u0e2d\u0e01\u0e0a\u0e37\u0e48\u0e2d-\u0e19\u0e32\u0e21\u0e2a\u0e01\u0e38\u0e25",
        emailRequired: "\u0e42\u0e1b\u0e23\u0e14\u0e01\u0e23\u0e2d\u0e01\u0e2d\u0e35\u0e40\u0e21\u0e25",
        emailInvalid: "\u0e42\u0e1b\u0e23\u0e14\u0e01\u0e23\u0e2d\u0e01\u0e2d\u0e35\u0e40\u0e21\u0e25\u0e17\u0e35\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07",
        inviteRequired: "\u0e42\u0e1b\u0e23\u0e14\u0e43\u0e0a\u0e49\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e17\u0e35\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07",
        termsRequired: "\u0e42\u0e1b\u0e23\u0e14\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e27\u0e48\u0e32\u0e04\u0e38\u0e13\u0e44\u0e14\u0e49\u0e2d\u0e48\u0e32\u0e19\u0e41\u0e25\u0e30\u0e22\u0e2d\u0e21\u0e23\u0e31\u0e1a\u0e40\u0e07\u0e37\u0e48\u0e2d\u0e19\u0e44\u0e02\u0e41\u0e25\u0e49\u0e27",
      },
    },
    assessment: {
      brand: "\u0e01\u0e32\u0e23\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25",
      inviteCode: "\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d",
      backButton: "\u0e22\u0e49\u0e2d\u0e19\u0e01\u0e25\u0e31\u0e1a",
      nextButton: "\u0e16\u0e31\u0e14\u0e44\u0e1b",
      completeButton: "\u0e40\u0e2a\u0e23\u0e47\u0e08\u0e2a\u0e34\u0e49\u0e19",
      dragInstruction:
        "\u0e25\u0e32\u0e01\u0e41\u0e25\u0e30\u0e27\u0e32\u0e07\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e08\u0e31\u0e14\u0e25\u0e33\u0e14\u0e31\u0e1a\u0e08\u0e32\u0e01\u0e2a\u0e33\u0e04\u0e31\u0e0d\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14 (1) \u0e44\u0e1b\u0e2b\u0e32\u0e19\u0e49\u0e2d\u0e22\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14",
      helperDefault: "\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e04\u0e33\u0e15\u0e2d\u0e1a\u0e17\u0e35\u0e48\u0e15\u0e23\u0e07\u0e01\u0e31\u0e1a\u0e2a\u0e16\u0e32\u0e19\u0e01\u0e32\u0e23\u0e13\u0e4c\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e21\u0e32\u0e01\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14",
      helperCheckbox: "\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e44\u0e14\u0e49\u0e17\u0e38\u0e01\u0e02\u0e49\u0e2d\u0e17\u0e35\u0e48\u0e15\u0e23\u0e07",
      helperRanking: "\u0e25\u0e32\u0e01\u0e41\u0e15\u0e48\u0e25\u0e30\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e08\u0e31\u0e14\u0e25\u0e33\u0e14\u0e31\u0e1a",
      helperGrouped: "\u0e42\u0e1b\u0e23\u0e14\u0e15\u0e2d\u0e1a\u0e17\u0e38\u0e01\u0e41\u0e16\u0e27\u0e01\u0e48\u0e2d\u0e19\u0e14\u0e33\u0e40\u0e19\u0e34\u0e19\u0e15\u0e48\u0e2d",
      helperText: "\u0e1e\u0e34\u0e21\u0e1e\u0e4c\u0e04\u0e33\u0e15\u0e2d\u0e1a\u0e14\u0e49\u0e27\u0e22\u0e04\u0e33\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e40\u0e2d\u0e07",
      helperLikert: "\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e44\u0e14\u0e49\u0e40\u0e1e\u0e35\u0e22\u0e07\u0e02\u0e49\u0e2d\u0e40\u0e14\u0e35\u0e22\u0e27",
      otherPlaceholder: "\u0e42\u0e1b\u0e23\u0e14\u0e23\u0e30\u0e1a\u0e38",
      errorAnswerRequired: "\u0e42\u0e1b\u0e23\u0e14\u0e15\u0e2d\u0e1a\u0e04\u0e33\u0e16\u0e32\u0e21\u0e19\u0e35\u0e49\u0e01\u0e48\u0e2d\u0e19\u0e14\u0e33\u0e40\u0e19\u0e34\u0e19\u0e15\u0e48\u0e2d",
      errorOtherRequired:
        "\u0e42\u0e1b\u0e23\u0e14\u0e23\u0e30\u0e1a\u0e38\u0e04\u0e33\u0e15\u0e2d\u0e1a \u201c\u0e2d\u0e37\u0e48\u0e19\u0e46\u201d \u0e01\u0e48\u0e2d\u0e19\u0e14\u0e33\u0e40\u0e19\u0e34\u0e19\u0e15\u0e48\u0e2d",
    },
    completion: {
      title: "\u0e17\u0e33\u0e41\u0e1a\u0e1a\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e40\u0e23\u0e35\u0e22\u0e1a\u0e23\u0e49\u0e2d\u0e22",
      subtitle: "\u0e02\u0e2d\u0e1a\u0e04\u0e38\u0e13\u0e17\u0e35\u0e48\u0e40\u0e02\u0e49\u0e32\u0e23\u0e48\u0e27\u0e21",
      resultsReady: "\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e43\u0e2b\u0e49\u0e14\u0e39\u0e41\u0e25\u0e49\u0e27",
      viewResultsButton: "\u0e14\u0e39\u0e1c\u0e25\u0e25\u0e31\u0e1e\u0e18\u0e4c",
      emailSent: "\u0e01\u0e33\u0e25\u0e31\u0e07\u0e40\u0e15\u0e23\u0e35\u0e22\u0e21\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e08\u0e31\u0e14\u0e2a\u0e48\u0e07\u0e17\u0e32\u0e07\u0e2d\u0e35\u0e40\u0e21\u0e25",
      emailNote: "\u0e42\u0e1b\u0e23\u0e14\u0e15\u0e23\u0e27\u0e08\u0e01\u0e25\u0e48\u0e2d\u0e07\u0e08\u0e14\u0e2b\u0e21\u0e32\u0e22\u0e20\u0e32\u0e22\u0e43\u0e19 24 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",
      savedNote:
        "\u0e23\u0e30\u0e1a\u0e1a\u0e44\u0e14\u0e49\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e04\u0e33\u0e15\u0e2d\u0e1a\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e41\u0e25\u0e49\u0e27 \u0e1c\u0e39\u0e49\u0e08\u0e31\u0e14\u0e08\u0e30\u0e41\u0e0a\u0e23\u0e4c\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e15\u0e32\u0e21\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e02\u0e2d\u0e07\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e19\u0e35\u0e49",
      emailError:
        "\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e2a\u0e48\u0e07\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e17\u0e32\u0e07\u0e2d\u0e35\u0e40\u0e21\u0e25\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34\u0e44\u0e14\u0e49 \u0e42\u0e1b\u0e23\u0e14\u0e25\u0e2d\u0e07\u0e43\u0e2b\u0e21\u0e48\u0e43\u0e19\u0e20\u0e32\u0e22\u0e2b\u0e25\u0e31\u0e07\u0e2b\u0e23\u0e37\u0e2d\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e1c\u0e39\u0e49\u0e08\u0e31\u0e14",
    },
    results: {
      brand: "\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25",
      inviteCode: "\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d",
      title: "\u0e1c\u0e25\u0e01\u0e32\u0e23\u0e1b\u0e23\u0e30\u0e40\u0e21\u0e34\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25",
      overallScore: "\u0e04\u0e30\u0e41\u0e19\u0e19\u0e23\u0e27\u0e21",
      overallScoreDesc:
        "\u0e04\u0e33\u0e19\u0e27\u0e13\u0e08\u0e32\u0e01\u0e04\u0e33\u0e15\u0e2d\u0e1a\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e43\u0e19 4 \u0e21\u0e34\u0e15\u0e34\u0e2a\u0e33\u0e04\u0e31\u0e0d\u0e02\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e27\u0e34\u0e19\u0e34\u0e08\u0e09\u0e31\u0e22\u0e19\u0e35\u0e49",
      outOf: "/ 100",
      categoryBreakdown: "\u0e41\u0e22\u0e01\u0e15\u0e32\u0e21\u0e2b\u0e21\u0e27\u0e14",
      scoreComparison: "\u0e40\u0e1b\u0e23\u0e35\u0e22\u0e1a\u0e40\u0e17\u0e35\u0e22\u0e1a\u0e04\u0e30\u0e41\u0e19\u0e19",
      downloadButton: "\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19",
      strengthsTitle: "\u0e04\u0e27\u0e32\u0e21\u0e2b\u0e21\u0e32\u0e22\u0e02\u0e2d\u0e07\u0e1c\u0e25\u0e25\u0e31\u0e1e\u0e18\u0e4c",
      nextStepsTitle: "\u0e02\u0e31\u0e49\u0e19\u0e15\u0e2d\u0e19\u0e41\u0e19\u0e30\u0e19\u0e33",
      scoreBadgeLabel: "\u0e04\u0e30\u0e41\u0e19\u0e19",
    },
    delivery: {
      brand: "\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e2a\u0e38\u0e02\u0e20\u0e32\u0e27\u0e30\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25",
      inviteCode: "\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d",
      title: "\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13",
      subtitle:
        "\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e27\u0e34\u0e18\u0e35\u0e40\u0e01\u0e47\u0e1a\u0e2a\u0e33\u0e40\u0e19\u0e32\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e01\u0e32\u0e23\u0e27\u0e34\u0e19\u0e34\u0e08\u0e09\u0e31\u0e22\u0e19\u0e35\u0e49",
      warningTitle: "\u0e2a\u0e33\u0e04\u0e31\u0e0d: \u0e2d\u0e32\u0e08\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49\u0e40\u0e02\u0e49\u0e32\u0e16\u0e36\u0e07\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e19\u0e35\u0e49\u0e15\u0e25\u0e2d\u0e14\u0e44\u0e1b",
      warningDesc:
        "\u0e2b\u0e32\u0e01\u0e04\u0e38\u0e13\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e40\u0e01\u0e47\u0e1a\u0e2a\u0e33\u0e40\u0e19\u0e32 \u0e04\u0e27\u0e23\u0e14\u0e32\u0e27\u0e19\u0e4c\u0e42\u0e2b\u0e25\u0e14\u0e2b\u0e23\u0e37\u0e2d\u0e2a\u0e48\u0e07\u0e17\u0e32\u0e07\u0e2d\u0e35\u0e40\u0e21\u0e25\u0e17\u0e31\u0e19\u0e17\u0e35",
      downloadPDF: "\u0e14\u0e32\u0e27\u0e19\u0e4c\u0e42\u0e2b\u0e25\u0e14 PDF",
      downloadPDFDesc:
        "\u0e23\u0e31\u0e1a\u0e40\u0e2d\u0e01\u0e2a\u0e32\u0e23 PDF \u0e40\u0e15\u0e47\u0e21\u0e23\u0e39\u0e1b\u0e41\u0e1a\u0e1a\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e04\u0e30\u0e41\u0e19\u0e19 \u0e1c\u0e25\u0e15\u0e32\u0e21\u0e2b\u0e21\u0e27\u0e14 \u0e41\u0e25\u0e30\u0e02\u0e49\u0e2d\u0e40\u0e2a\u0e19\u0e2d\u0e41\u0e19\u0e30",
      emailReport: "\u0e2a\u0e48\u0e07\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e17\u0e32\u0e07\u0e2d\u0e35\u0e40\u0e21\u0e25",
      emailReportDesc: "\u0e2a\u0e48\u0e07\u0e23\u0e32\u0e22\u0e07\u0e32\u0e19\u0e44\u0e1b\u0e22\u0e31\u0e07",
      supportNote: "\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e04\u0e27\u0e32\u0e21\u0e0a\u0e48\u0e27\u0e22\u0e40\u0e2b\u0e25\u0e37\u0e2d? \u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d support@kigumigroup.com",
      unavailable: "\u0e27\u0e34\u0e18\u0e35\u0e19\u0e35\u0e49\u0e16\u0e39\u0e01\u0e1b\u0e34\u0e14\u0e44\u0e27\u0e49\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e23\u0e2b\u0e31\u0e2a\u0e40\u0e0a\u0e34\u0e0d\u0e19\u0e35\u0e49",
      emailSending: "\u0e01\u0e33\u0e25\u0e31\u0e07\u0e2a\u0e48\u0e07...",
    },
    footer: {
      stayUpdated: "\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14",
      description:
        "\u0e23\u0e31\u0e1a\u0e41\u0e19\u0e27\u0e04\u0e34\u0e14\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e01\u0e32\u0e23\u0e28\u0e36\u0e01\u0e29\u0e32\u0e14\u0e34\u0e08\u0e34\u0e17\u0e31\u0e25\u0e41\u0e25\u0e30\u0e08\u0e23\u0e34\u0e22\u0e18\u0e23\u0e23\u0e21 AI",
      placeholder: "\u0e01\u0e23\u0e2d\u0e01\u0e2d\u0e35\u0e40\u0e21\u0e25\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13",
      subscribe: "\u0e2a\u0e21\u0e31\u0e04\u0e23\u0e23\u0e31\u0e1a\u0e02\u0e48\u0e32\u0e27\u0e2a\u0e32\u0e23",
      marketingConsent:
        "\u0e09\u0e31\u0e19\u0e22\u0e34\u0e19\u0e22\u0e2d\u0e21\u0e23\u0e31\u0e1a\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e01\u0e32\u0e23\u0e15\u0e25\u0e32\u0e14\u0e08\u0e32\u0e01 Kigumigroup",
      followUs: "\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e40\u0e23\u0e32",
      copyright: "\u00a9 Kigumi Group 2026",
      confirmationTitle: "\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e01\u0e32\u0e23\u0e2a\u0e21\u0e31\u0e04\u0e23\u0e41\u0e25\u0e49\u0e27!",
      confirmationMessage:
        "\u0e02\u0e2d\u0e1a\u0e04\u0e38\u0e13\u0e17\u0e35\u0e48\u0e2a\u0e21\u0e31\u0e04\u0e23! \u0e40\u0e23\u0e32\u0e08\u0e30\u0e2a\u0e48\u0e07\u0e2d\u0e31\u0e1b\u0e40\u0e14\u0e15\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14\u0e44\u0e1b\u0e22\u0e31\u0e07",
      confirmationButton: "\u0e40\u0e02\u0e49\u0e32\u0e43\u0e08\u0e41\u0e25\u0e49\u0e27",
    },
  },
  ja: {
    welcome: {
      selectLanguage: "Language",
      title: "\u3088\u3046\u3053\u305d",
      titleHighlight: "\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u8a3a\u65ad\u3078",
      subtitle:
        "\u5bb6\u5ead\u306e\u30c7\u30b8\u30bf\u30eb\u80b2\u5150\u6e96\u5099\u5ea6\u3092\u3001\u308f\u304b\u308a\u3084\u3059\u304f\u8a3a\u65ad\u3057\u307e\u3059",
      assessmentTitle:
        "\u5bb6\u5ead\u306e\u30b5\u30a4\u30d0\u30fc\u5b89\u5168\u3068\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u8a3a\u65ad",
      assessmentDescription:
        "保護者向けプログラムに投資する前に、まず家庭がどのような支援を必要としているかを把握しましょう。この診断は数分で完了し、保護者コンピテンシーの4つの重要領域にわたる個別スコアと洞察を提供します。",
      startAssessmentButton: "\u8a3a\u65ad\u3092\u59cb\u3081\u308b",
      startButton: "\u8a3a\u65ad\u306b\u9032\u3080",
      languageNote:
        "\u8a3a\u65ad\u306e\u5168\u30d5\u30ed\u30fc\u306f\u9078\u629e\u3057\u305f\u8a00\u8a9e\u3067\u5229\u7528\u3067\u304d\u307e\u3059",
      ...WELCOME_SHARED_BY_LANGUAGE.ja,
    },
    landing: {
      inviteCode: "\u62db\u5f85\u30b3\u30fc\u30c9",
      missingInviteCode: "\u624b\u52d5\u5165\u529b",
      title: "\u5bb6\u5ead\u306e\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u8a55\u4fa1",
      subtitle:
        "\u6b21\u306e\u652f\u63f4\u3092\u8a08\u753b\u3059\u308b\u524d\u306b\u3001\u73fe\u5728\u306e\u30c7\u30b8\u30bf\u30eb\u74b0\u5883\u3092\u7406\u89e3\u3057\u307e\u3059\u3002",
      duration: "10-15\u5206",
      durationDesc:
        "\u30c7\u30b9\u30af\u30c8\u30c3\u30d7\u3067\u3082\u30e2\u30d0\u30a4\u30eb\u3067\u3082\u3001\u307e\u3068\u307e\u3063\u305f\u6642\u9593\u3067\u5b8c\u4e86\u3067\u304d\u308b\u8a3a\u65ad\u3067\u3059\u3002",
      noLogin: "\u30ed\u30b0\u30a4\u30f3\u4e0d\u8981",
      noLoginDesc:
        "\u62db\u5f85\u30ea\u30f3\u30af\u304b\u3089\u958b\u59cb\u3059\u308b\u304b\u3001\u30d5\u30a9\u30fc\u30e0\u3067\u62db\u5f85\u30b3\u30fc\u30c9\u3092\u624b\u52d5\u5165\u529b\u3067\u304d\u307e\u3059\u3002",
      oneTimeReport: "\u62db\u5f85\u30b3\u30fc\u30c9\u3067\u30ec\u30dd\u30fc\u30c8\u52d5\u4f5c\u3092\u5236\u5fa1",
      oneTimeReportDesc:
        "\u62db\u5f85\u30b3\u30fc\u30c9\u3067\u3001\u5f79\u5272\u3001\u8a55\u4fa1\u30d5\u30a7\u30fc\u30ba\u3001\u7d50\u679c\u8868\u793a\u3001\u4e0b\u8f09\u3001\u30e1\u30fc\u30eb\u9001\u4fe1\u306e\u53ef\u5426\u3092\u6307\u5b9a\u3067\u304d\u307e\u3059\u3002",
      startButton: "\u8a3a\u65ad\u3092\u59cb\u3081\u308b",
      footerNote:
        "\u56de\u7b54\u306f\u3001Kigumi \u3068\u5b66\u6821\u30d1\u30fc\u30c8\u30ca\u30fc\u304c\u5bb6\u5ead\u306b\u5fc5\u8981\u306a\u652f\u63f4\u3092\u7406\u89e3\u3059\u308b\u305f\u3081\u306b\u5f79\u7acb\u3061\u307e\u3059\u3002",
      invitationLink: "\u62db\u5f85\u30ea\u30f3\u30af",
      invitationLinkConfirmed: "\u62db\u5f85\u30ea\u30f3\u30af\u3092\u78ba\u8a8d\u3057\u307e\u3057\u305f",
      invitationLinkLoading: "\u62db\u5f85\u30ea\u30f3\u30af\u3092\u78ba\u8a8d\u4e2d...",
      invitationLinkNote:
        "\u3053\u306e\u30ea\u30f3\u30af\u3092\u4f7f\u3046\u5834\u5408\u3001\u62db\u5f85\u30b3\u30fc\u30c9\u306e\u5165\u529b\u306f\u4e0d\u8981\u3067\u3059\u3002",
      inviteCodeConfirmed: "\u62db\u5f85\u30b3\u30fc\u30c9\u3092\u78ba\u8a8d\u3057\u307e\u3057\u305f",
      inviteCodeLoading: "\u62db\u5f85\u30b3\u30fc\u30c9\u3092\u78ba\u8a8d\u4e2d...",
      inviteCodeInvalid:
        "\u3053\u306e\u62db\u5f85\u30b3\u30fc\u30c9\u306f\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3002/diagnostic \u3067\u624b\u52d5\u30e2\u30fc\u30c9\u3092\u4f7f\u3046\u304b\u3001\u6b63\u3057\u3044 /start \u30ea\u30f3\u30af\u3092\u4f7f\u3063\u3066\u304f\u3060\u3055\u3044\u3002",
    },
    form: {
      title: "\u57fa\u672c\u60c5\u5831",
      subtitle: "\u8a3a\u65ad\u3092\u958b\u59cb\u3059\u308b\u524d\u306b\u60c5\u5831\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
      fullName: "\u6c0f\u540d",
      email: "\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9",
      role: "\u79c1\u306f...",
      studentClass: "\u5b66\u5e74 / \u30af\u30e9\u30b9",
      inviteCode: "\u62db\u5f85\u30b3\u30fc\u30c9",
      language: "\u8a55\u4fa1\u8a00\u8a9e",
      inviteCodeNote:
        "\u62db\u5f85\u30ea\u30f3\u30af\u3092\u4f7f\u3063\u305f\u5834\u5408\u306f\u81ea\u52d5\u3067\u5165\u529b\u3055\u308c\u307e\u3059\u3002\u3053\u3053\u3067\u624b\u52d5\u5165\u529b\u3082\u3067\u304d\u307e\u3059\u3002",
      inviteLinkConfirmedTitle: "\u62db\u5f85\u30ea\u30f3\u30af\u3092\u78ba\u8a8d\u3057\u307e\u3057\u305f",
      inviteLinkConfirmedNote:
        "\u62db\u5f85\u30b3\u30fc\u30c9\u306e\u5165\u529b\u306f\u4e0d\u8981\u3067\u3059\u3002\u3053\u306e\u30ea\u30f3\u30af\u306b\u3088\u308a\u3001\u6b63\u3057\u3044\u8a55\u4fa1\u30d5\u30ed\u30fc\u304c\u4fdd\u305f\u308c\u307e\u3059\u3002",
      inviteCodeLockedNote:
        "\u3053\u306e\u62db\u5f85\u30b3\u30fc\u30c9\u306f\u62db\u5f85\u30ea\u30f3\u30af\u304b\u3089\u81ea\u52d5\u8a2d\u5b9a\u3055\u308c\u3066\u304a\u308a\u3001\u8a2d\u554f\u30bb\u30c3\u30c8\u3084\u8a55\u4fa1\u6761\u4ef6\u304c\u5909\u308f\u3089\u306a\u3044\u3088\u3046\u30ed\u30c3\u30af\u3055\u308c\u3066\u3044\u307e\u3059\u3002",
      roleLocked: "\u3053\u306e\u5f79\u5272\u306f\u62db\u5f85\u30ea\u30f3\u30af\u304b\u3089\u81ea\u52d5\u8a2d\u5b9a\u3055\u308c\u307e\u3059\u3002",
      terms: "\u5229\u7528\u898f\u7d04\u3092\u8aad\u307f\u3001\u540c\u610f\u3057\u307e\u3059\u3002",
      submitButton: "\u8a3a\u65ad\u3092\u958b\u59cb",
      backButton: "\u623b\u308b",
      submitDisabledInvite:
        "\u3053\u306e\u30ea\u30f3\u30af\u3092\u7d9a\u3051\u308b\u306b\u306f\u6709\u52b9\u306a\u62db\u5f85\u30b3\u30fc\u30c9\u304c\u5fc5\u8981\u3067\u3059\u3002",
      placeholders: {
        fullName: "\u6c0f\u540d\u3092\u5165\u529b",
        email: "your.email@example.com",
        studentClass: "\u4f8b\uff1aGrade 10A",
        inviteCode: "\u62db\u5f85\u30b3\u30fc\u30c9\u3092\u5165\u529b",
      },
      errors: {
        nameRequired: "\u6c0f\u540d\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
        emailRequired: "\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
        emailInvalid:
          "\u6709\u52b9\u306a\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
        inviteRequired:
          "\u6709\u52b9\u306a\u62db\u5f85\u30b3\u30fc\u30c9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
        termsRequired:
          "\u5229\u7528\u898f\u7d04\u3092\u8aad\u307f\u3001\u540c\u610f\u3057\u305f\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044",
      },
    },
    assessment: {
      brand: "\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u8a55\u4fa1",
      inviteCode: "\u62db\u5f85\u30b3\u30fc\u30c9",
      backButton: "\u623b\u308b",
      nextButton: "\u6b21\u3078",
      completeButton: "\u5b8c\u4e86",
      dragInstruction:
        "\u91cd\u8981\u5ea6\u306e\u9ad8\u3044\u9806\u306b\u30c9\u30e9\u30c3\u30b0\u3057\u3066\u4e26\u3079\u66ff\u3048\u3066\u304f\u3060\u3055\u3044",
      helperDefault:
        "\u73fe\u5728\u306e\u72b6\u6cc1\u306b\u6700\u3082\u8fd1\u3044\u56de\u7b54\u3092\u9078\u3093\u3067\u304f\u3060\u3055\u3044",
      helperCheckbox: "\u5f53\u3066\u306f\u307e\u308b\u3082\u306e\u3092\u3059\u3079\u3066\u9078\u3093\u3067\u304f\u3060\u3055\u3044",
      helperRanking: "\u5404\u9805\u76ee\u3092\u30c9\u30e9\u30c3\u30b0\u3057\u3066\u9806\u5e8f\u3092\u6c7a\u3081\u3066\u304f\u3060\u3055\u3044",
      helperGrouped: "\u6b21\u306b\u9032\u3080\u524d\u306b\u3059\u3079\u3066\u306e\u884c\u306b\u56de\u7b54\u3057\u3066\u304f\u3060\u3055\u3044",
      helperText: "\u3054\u81ea\u8eab\u306e\u8a00\u8449\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
      helperLikert: "\u4e00\u3064\u9078\u3093\u3067\u304f\u3060\u3055\u3044",
      otherPlaceholder: "\u8a73\u7d30\u3092\u8a18\u5165",
      errorAnswerRequired:
        "\u7d9a\u884c\u3059\u308b\u524d\u306b\u3053\u306e\u8cea\u554f\u306b\u56de\u7b54\u3057\u3066\u304f\u3060\u3055\u3044",
      errorOtherRequired:
        "\u300c\u305d\u306e\u4ed6\u300d\u3092\u9078\u3093\u3060\u5834\u5408\u306f\u8a73\u7d30\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
    },
    completion: {
      title: "\u8a55\u4fa1\u304c\u5b8c\u4e86\u3057\u307e\u3057\u305f",
      subtitle: "\u3054\u53c2\u52a0\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3057\u305f",
      resultsReady: "\u30ec\u30dd\u30fc\u30c8\u306e\u95b2\u89a7\u6e96\u5099\u304c\u3067\u304d\u307e\u3057\u305f",
      viewResultsButton: "\u7d50\u679c\u3092\u898b\u308b",
      emailSent:
        "\u30ec\u30dd\u30fc\u30c8\u3092\u30e1\u30fc\u30eb\u9001\u4fe1\u3059\u308b\u305f\u3081\u306e\u6e96\u5099\u3092\u3057\u3066\u3044\u307e\u3059",
      emailNote: "24\u6642\u9593\u4ee5\u5185\u306b\u53d7\u4fe1\u30dc\u30c3\u30af\u30b9\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044",
      savedNote:
        "\u56de\u7b54\u306f\u8a18\u9332\u3055\u308c\u307e\u3057\u305f\u3002\u30ec\u30dd\u30fc\u30c8\u306f\u62db\u5f85\u30b3\u30fc\u30c9\u306e\u8a2d\u5b9a\u306b\u3088\u3063\u3066\u4e3b\u50ac\u8005\u304b\u3089\u5171\u6709\u3055\u308c\u307e\u3059\u3002",
      emailError:
        "\u30ec\u30dd\u30fc\u30c8\u306e\u81ea\u52d5\u30e1\u30fc\u30eb\u9001\u4fe1\u306b\u5931\u6557\u3057\u307e\u3057\u305f\u3002\u5f8c\u307b\u3069\u518d\u8a66\u884c\u3059\u308b\u304b\u3001\u4e3b\u50ac\u8005\u306b\u9023\u7d61\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
    },
    results: {
      brand: "\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u30ec\u30dd\u30fc\u30c8",
      inviteCode: "\u62db\u5f85\u30b3\u30fc\u30c9",
      title: "\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u8a55\u4fa1\u7d50\u679c",
      overallScore: "\u7dcf\u5408\u30b9\u30b3\u30a2",
      overallScoreDesc:
        "\u30d5\u30a1\u30df\u30ea\u30fc\u306e\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u306b\u95a2\u3059\u308b 4 \u3064\u306e\u4e3b\u8981\u9818\u57df\u306e\u56de\u7b54\u3092\u57fa\u306b\u7b97\u51fa\u3057\u3066\u3044\u307e\u3059\u3002",
      outOf: "/ 100",
      categoryBreakdown: "\u30ab\u30c6\u30b4\u30ea\u5225\u5185\u8a33",
      scoreComparison: "\u30b9\u30b3\u30a2\u6bd4\u8f03",
      downloadButton: "\u30ec\u30dd\u30fc\u30c8\u3092\u4fdd\u5b58",
      strengthsTitle: "\u3053\u306e\u7d50\u679c\u304c\u610f\u5473\u3059\u308b\u3053\u3068",
      nextStepsTitle: "\u6b21\u306e\u30b9\u30c6\u30c3\u30d7",
      scoreBadgeLabel: "\u30b9\u30b3\u30a2",
    },
    delivery: {
      brand: "\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u30ec\u30dd\u30fc\u30c8",
      inviteCode: "\u62db\u5f85\u30b3\u30fc\u30c9",
      title: "\u30ec\u30dd\u30fc\u30c8\u3092\u4fdd\u5b58\u3059\u308b",
      subtitle:
        "\u3053\u306e\u30c7\u30b8\u30bf\u30eb\u30a6\u30a7\u30eb\u30d3\u30fc\u30a4\u30f3\u30b0\u8a3a\u65ad\u30ec\u30dd\u30fc\u30c8\u3092\u4fdd\u7ba1\u3059\u308b\u65b9\u6cd5\u3092\u9078\u3093\u3067\u304f\u3060\u3055\u3044",
      warningTitle: "\u91cd\u8981: \u3053\u306e\u30ec\u30dd\u30fc\u30c8\u306f\u5f8c\u3067\u8868\u793a\u3067\u304d\u306a\u304f\u306a\u308b\u53ef\u80fd\u6027\u304c\u3042\u308a\u307e\u3059",
      warningDesc:
        "\u5fc5\u8981\u306a\u5834\u5408\u306f\u3001\u3053\u306e\u30bf\u30a4\u30df\u30f3\u30b0\u3067\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9\u307e\u305f\u306f\u30e1\u30fc\u30eb\u9001\u4fe1\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
      downloadPDF: "PDF \u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9",
      downloadPDFDesc:
        "\u30b9\u30b3\u30a2\u3001\u30ab\u30c6\u30b4\u30ea\u5225\u7d50\u679c\u3001\u6b21\u306e\u30b9\u30c6\u30c3\u30d7\u3092\u542b\u3080\u5b8c\u6574\u306a PDF \u3092\u53d6\u5f97\u3057\u307e\u3059\u3002",
      emailReport: "\u30ec\u30dd\u30fc\u30c8\u3092\u30e1\u30fc\u30eb\u9001\u4fe1",
      emailReportDesc: "\u9001\u4fe1\u5148",
      supportNote:
        "\u304a\u56f0\u308a\u306e\u5834\u5408\u306f support@kigumigroup.com \u3078\u3054\u9023\u7d61\u304f\u3060\u3055\u3044",
      unavailable:
        "\u73fe\u5728\u306e\u62db\u5f85\u30b3\u30fc\u30c9\u3067\u306f\u3053\u306e\u4fdd\u5b58\u65b9\u6cd5\u306f\u5229\u7528\u3067\u304d\u307e\u305b\u3093\u3002",
      emailSending: "\u9001\u4fe1\u4e2d...",
    },
    footer: {
      stayUpdated: "\u6700\u65b0\u60c5\u5831\u3092\u53d7\u3051\u53d6\u308b",
      description:
        "\u30c7\u30b8\u30bf\u30eb\u6559\u80b2\u3068 AI \u502b\u7406\u306b\u95a2\u3059\u308b\u6700\u65b0\u306e\u30a4\u30f3\u30b5\u30a4\u30c8\u3092\u53d7\u3051\u53d6\u308b",
      placeholder: "\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b",
      subscribe: "\u8cfc\u8aad\u3059\u308b",
      marketingConsent:
        "Kigumigroup \u304b\u3089\u306e\u30de\u30fc\u30b1\u30c6\u30a3\u30f3\u30b0\u9023\u7d61\u3092\u53d7\u3051\u53d6\u308b\u3053\u3068\u306b\u540c\u610f\u3057\u307e\u3059",
      followUs: "\u30d5\u30a9\u30ed\u30fc\u3059\u308b",
      copyright: "\u00a9 Kigumi Group 2026",
      confirmationTitle: "\u8cfc\u8aad\u304c\u78ba\u8a8d\u3055\u308c\u307e\u3057\u305f",
      confirmationMessage:
        "\u3054\u8cfc\u8aad\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u6700\u65b0\u60c5\u5831\u3092\u3053\u3061\u3089\u306b\u304a\u5c4a\u3051\u3057\u307e\u3059",
      confirmationButton: "\u4e86\u89e3",
    },
  },
};

export function getExperienceCopy(language) {
  return EXPERIENCE_COPY[language] || EXPERIENCE_COPY.en;
}
